module.exports = __webpack_public_path__ + "static/media/coatpicture.b8fd571e.jpg";